<template>
  <section class="requisites">
    <div class="container">
      <div class="card">
        <h1 class="title">Реквизиты</h1>
        <div class="grid">
          <div v-for="(item, i) in requisites" :key="i" class="cell">
            <div class="label">{{ item.label }}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const requisites = [
  {
    label: "Наименование компании / ИП",
    value: "ОБЩЕСТВО С ОГРАНИЧЕННОЙ ОТВЕТСТВЕННОСТЬЮ",
  },
  {
    label: "Юридический адрес организации",
    value:
      "127434, РОССИЯ, Г.МОСКВА, ВН.ТЕР.Г. МУНИЦИПАЛЬНЫЙ ОКРУГ ТИМИРЯЗЕВСКИЙ, УЛ ДУБКИ, Д. 6",
  },
  { label: "ИНН", value: "6155077624" },
  { label: "Наименование банка", value: "АО «ТБанк»" },
  { label: "ИНН банка", value: "7710140679" },
  {
    label: "Корреспондентский счёт",
    value: "30101810145250000974",
  },

  { label: "Расчётный счёт", value: "40702810010001887690" },
  { label: "БИК банка", value: "044525974" },
  { label: "КПП банка по месту нахождения", value: "771301001" },
];
</script>

<style scoped>
.requisites {
  background: #f7fafc;
  padding: 60px 20px;
}
.container {
  margin: 0 auto;
}
.title {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 30px;
  color: rgba(0, 199, 130, 1);
}
.card {
  background: #fff;
  border-radius: 30px;
  padding: 48px 100px;
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
  border: none;
}
.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 48px 60px;
}
.cell {
  display: flex;
  flex-direction: column;
}
.label {
  color: rgba(109, 115, 124, 1);
  font-size: 20px;
  margin-bottom: 24px;
}
.value {
  color: rgba(62, 62, 62, 1);
  font-size: 20px;
  font-weight: 700;
}
</style>
